import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../button/Button";

interface ISuccessPopupProps {
    isOpen: boolean;
    message: string;
    onClose: () => void;
}

const SuccessPopup: React.FC<ISuccessPopupProps> = ({
    isOpen,
    message,
    onClose
}) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 relative border-2 border-red">
                {/* Icona di successo e testo sulla stessa riga */}
                <div className="flex items-center justify-center mb-6">
                    <div className="w-8 h-8 bg-green rounded-full flex items-center justify-center mr-3">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">
                        {t('common.success')}!
                    </h3>
                </div>

                {/* Messaggio */}
                <div className="text-center mb-8">
                    <p className="text-gray-600 leading-relaxed">
                        {message}
                    </p>
                </div>

                {/* Pulsante OK */}
                <div className="flex justify-end">
                    <Button
                        callback={onClose}
                        className="bg-red text-white px-6 py-2 rounded hover:bg-red-dark"
                    >
                        OK
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SuccessPopup; 
